export interface AuthData {
  access_token: string
  refresh_token: string
  expires_in: number
}

export class TrackedLoginModalSourceDto {
  source: string;
  [key: string]: unknown

  constructor(source: string, context: Record<string, unknown> = {}) {
    this.source = source
    Object.assign(this, context)
  }
}
